module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-42.b7d5828c.svg";